import Vue from 'vue'
import {getPage,getDomainInfo,operDomainInfo,updateSate,loadDomainRole,updateDomainRole} from '@/api/domain'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const domain = {
  state: { 
		loading:false
  },

  mutations: {
     
  },

  actions: { 
		GetDomainPage ({ commit },record) {
		  return new Promise((resolve, reject) => {
		    getPage(record).then(response => {  
					 console.log(response)
		    	 resolve(response)
		    	 }).catch(error => {
		    		 reject(error)
		     }) 
		  })
		},
	GetDomainInfo ({ commit },record) {
		return new Promise((resolve, reject) => {
			getDomainInfo(record).then(response => {  
				console.log(response)
				resolve(response)
				}).catch(error => {
					reject(error)
			}) 
		})
	},
	OperDomainInfo({ commit },record){
		return new Promise((resolve, reject) => {
			operDomainInfo(record).then(response => {  
				console.log(response)
				resolve(response)
				}).catch(error => {
					reject(error)
			}) 
		})
	},
	UpdateSate({ commit },record){
		return new Promise((resolve, reject) => {
			updateSate(record).then(response => {  
				console.log(response)
				resolve(response)
				}).catch(error => {
					reject(error)
			}) 
		})
	},
	LoadDomainRole({ commit },record){
		return new Promise((resolve, reject) => {
			loadDomainRole(record).then(response => {  
				console.log(response)
				resolve(response)
				}).catch(error => {
					reject(error)
			}) 
		})
	},
	
	UpdateDomainRole({ commit },record){
		return new Promise((resolve, reject) => {
			updateDomainRole(record).then(response => {  
				console.log(response)
				resolve(response)
				}).catch(error => {
					reject(error)
			}) 
		})
	}
  }
	
}

export default domain
